import { AddBundleForm } from "@/components/Materials/Forms/AddBundleForm";
import { Modal } from "@/ui";

interface AddBundleModalProps {
  show: boolean;
  onClose: () => void;
}

export const AddBundleModal = ({ show, onClose }: AddBundleModalProps) => {
  return (
    <Modal
      show={show}
      onClose={onClose}
      title="Add Bundle"
      description="Create a new course or training bundle"
    >
      <AddBundleForm onClose={onClose} />
    </Modal>
  );
};
